import './Search.css';
import SlButton from '@shoelace-style/shoelace/dist/react/button/index.js';
import SlInput from '@shoelace-style/shoelace/dist/react/input/index.js';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';
import SlSelect from '@shoelace-style/shoelace/dist/react/select/index.js';
import SlOption from '@shoelace-style/shoelace/dist/react/option/index.js'
import SlTag from '@shoelace-style/shoelace/dist/react/tag/index.js';
import SlCard from '@shoelace-style/shoelace/dist/react/card/index.js';
import SlTooltip from '@shoelace-style/shoelace/dist/react/tooltip';
import SlBadge from '@shoelace-style/shoelace/dist/react/badge/index.js';
import { CDSUiIcons } from '@cencora-design-system/assets/icons';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import FilterBreadcrumbs from './FilterBreadcrumbs';
import { useApi } from './useApi';

export default function Search(props) {
    const [localSearchTerm, setLocalSearchTerm] = useState(props.searchTerm || "");
    const navigate = useNavigate();
    const searchInputRef = useRef(null);

    // Style the placeholder to be italic
    useEffect(() => {
        const inputEl = searchInputRef.current;
        if (inputEl && inputEl.shadowRoot) {
            const style = document.createElement('style');
            style.textContent = 'input::placeholder { font-style: italic; }';
            inputEl.shadowRoot.appendChild(style);
        }
    }, []);

    //method call on hitting search
    function handleSearch() {
        props.setSearchTerm(localSearchTerm);
    }

    function handleKeyDown(e) {
        if (e.key === "Enter") {
            handleSearch();
        }
    }

    function handleSortChange(e) {
        const newSortOrder = e.target.value === "newest" ? "DESC" : "ASC";
        props.setSortOrder(newSortOrder);
    }

    function handleViewDetails(item) {
        navigate(`/details/${item.id}`, { state: { record: item } });
    }

    return <div className="search-container">
        <div className="search-header">
            <div className="search-input-container">
                <div className="search-input-holder">
                    <SlInput
                        clearable
                        ref={searchInputRef}
                        className="search-input"
                        name="Input"
                        placeholder="Search"
                        size="medium"
                        type="text"
                        value={localSearchTerm}
                        onSlInput={(e) => setLocalSearchTerm(e.target.value)}
                        onKeyDown={handleKeyDown}
                    >


                    </SlInput>
                    <SlButton
                        className="search-button"
                        size="medium"
                        variant="primary"
                        onClick={handleSearch}
                    >
                        <SlIcon
                            label="Icon label"
                            size="3xl"
                            src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0idmFyKC0tY2RzLWljb24td2VpZ2h0LCAxLjUpIiBzdHlsZT0iYm94LXNpemluZzogYm9yZGVyLWJveDsgb3ZlcmZsb3c6IHZpc2libGU7IHBhZGRpbmc6IHZhcigtLWNkcy1pY29uLXBhZGRpbmcsIDApOyB0cmFuc2l0aW9uOiB2YXIoLS1jZHMtaWNvbi10cmFuc2l0aW9uLCAwcyk7Ij48ZyBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik0uNzUgOS44MTJBOS4wNjMgOS4wNjMgMCAxIDAgMTguODc2IDkuODEyIDkuMDYzIDkuMDYzIDAgMSAwIC43NSA5LjgxMloiIHRyYW5zZm9ybT0ibWF0cml4KC45MjAzMzQyOCAtLjM5MTEzMjc0IC4zOTExMzI3NCAuOTIwMzM0MjggLTMuMDU2IDQuNjIpIi8+PHBhdGggZD0iTTE2LjIyMSAxNi4yMiAyMy4yNSAyMy4yNSIvPjwvZz48L3N2Zz4="
                            weight="medium"
                        />
                    </SlButton>
                </div>

                <SlSelect
                    className="search-sort"
                    size="medium"
                    value={props.sortOrder === "DESC" ? "newest" : "oldest"}
                    onSlChange={handleSortChange}
                >
                    <React.Fragment key=".4">
                        <SlOption value="newest">
                            Newest to Oldest
                        </SlOption>
                        <SlOption value="oldest">
                            Oldest to Newest
                        </SlOption>
                    </React.Fragment>
                </SlSelect>

            </div>

        </div>
        {!props.isLoading && (props.results || []).length > 0 && (
            <div className="results-count">
                Showing {(props.results || []).length} of {props.pageData?.total || 0} results
            </div>
        )}
        <FilterBreadcrumbs selectedFilters={props.selectedFilters} handleRemove={props.handleRemove} setSelectedFilters={props.setSelectedFilters} />

        <div className="search-results-container">
            {props.isLoading ? (
                <div className="loading-container">
                    {/* Add your loading content here */}
                    <div className="loading-spinner"></div>
                    <p className="loading-text">Loading results...</p>
                </div>
            ) : (props.results || []).length === 0 ? (
                <div className="no-results-container">
                    <SlIcon
                        src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS41Ij48ZyBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik0uNzUgOS44MTJBOS4wNjMgOS4wNjMgMCAxIDAgMTguODc2IDkuODEyIDkuMDYzIDkuMDYzIDAgMSAwIC43NSA5LjgxMloiIHRyYW5zZm9ybT0ibWF0cml4KC45MjAzMzQyOCAtLjM5MTEzMjc0IC4zOTExMzI3NCAuOTIwMzM0MjggLTMuMDU2IDQuNjIpIi8+PHBhdGggZD0iTTE2LjIyMSAxNi4yMiAyMy4yNSAyMy4yNSIvPjwvZz48L3N2Zz4="
                        className="no-results-icon"
                    />
                    <p className="no-results-text">No matching results were found!</p>
                    <p className="no-results-subtext">Please refine your search</p>
                </div>
            ) : (
                (props.results || []).map((item) => (
                    <SearchResults key={item.id} item={item} onDislikeClick={props.onDislikeClick} onViewDetails={handleViewDetails} userId={props.userId} />
                ))
            )}

        </div>
    </div>
}

function SearchResults({ item, onDislikeClick, onViewDetails, userId }) {
    const { authPost, authDelete } = useApi();
    // Initialize like/dislike state from item data
    const [isLiked, setIsLiked] = useState(item.isLike || false);
    const [isDisliked, setIsDisliked] = useState(item.isDislike || false);
    const [copyTooltipText, setCopyTooltipText] = useState("Copy AI Summary");

    // Sync state when item data changes (e.g., after API response)
    useEffect(() => {
        setIsLiked(item.isLike || false);
    }, [item.isLike]);

    useEffect(() => {
        setIsDisliked(item.isDislike || false);
    }, [item.isDislike]);

    // Use userId from props (from auth context)
    const apiBaseUrl = process.env.REACT_APP_API_URL;
    const feedbackApi = `${apiBaseUrl}/userfeedback`;

    async function handleLikeClick() {
        try {
            // If already liked, DELETE to remove the like
            if (isLiked) {
                const response = await authDelete(`${feedbackApi}/${item.id}`);

                if (response.ok) {
                    setIsLiked(false);
                    console.log("Like feedback removed successfully");
                } else {
                    console.error("Failed to remove like feedback:", response.status);
                }
            } else {
                // POST to create like
                const response = await authPost(feedbackApi, {
                    userId: userId,
                    articleId: item.id,
                    feedbackType: "like"
                });

                if (response.ok) {
                    setIsLiked(true);
                    setIsDisliked(false);
                    console.log("Like feedback submitted successfully");
                } else {
                    console.error("Failed to submit like feedback:", response.status);
                }
            }
        } catch (error) {
            console.error("Error with like feedback:", error);
        }
    }

    async function handleDislikeClick() {
        // If already disliked, DELETE to remove the dislike
        if (isDisliked) {
            try {
                const response = await authDelete(`${feedbackApi}/${userId}/${item.id}`);

                if (response.ok) {
                    setIsDisliked(false);
                    console.log("Dislike feedback removed successfully");
                } else {
                    console.error("Failed to remove dislike feedback:", response.status);
                }
            } catch (error) {
                console.error("Error removing dislike feedback:", error);
            }
        } else {
            // Open modal to submit dislike with reasons
            onDislikeClick({
                ...item,
                onDislikeSubmit: () => {
                    setIsDisliked(true);
                    setIsLiked(false);
                }
            });
        }
    }

    function handleCopyAiSummary(e) {
        e.stopPropagation();
        const aiSummary = item.aiSummary || '';
        navigator.clipboard.writeText(aiSummary)
            .then(() => {
                setCopyTooltipText("AI Summary copied");
            })
            .catch(err => console.error('Failed to copy AI Summary:', err));
    }

    function resetCopyTooltip() {
        setCopyTooltipText("Copy AI Summary");
    }

    return <div className="search-result">
        <SlCard className="search-result-card">
            <div className="search-result-header">
                <div className="search-result-tags">
                    {item.categories?.map((category, index) => (<SlBadge
                        key={index}
                        className="category-badge"
                        size="medium"
                        pill
                    >
                        {category}
                    </SlBadge>))}
                    {item.region && (<SlBadge
                        className="category-badge"
                        size="medium"
                        pill
                    >
                        <span className="country-tag-content">
                            <SlIcon
                                src={CDSUiIcons.IconPin}
                                label="Location"
                            />
                            <span>{item.region}</span>
                        </span>
                    </SlBadge>)}

                </div>
                <div className="search-result-feedback-icons">
                    <SlTooltip content="Click the Like button if you think the information in the article is accurate, relevant, and useful.">
                        <SlIcon
                            className="search-result-like"
                            label="Icon label"
                            src={isLiked ? "/Icons/Like_Active.svg" : "/Icons/Like.svg"}
                            style={{ color: isLiked ? "#461e96" : "inherit", cursor: "pointer" }}
                            weight="medium"
                            onClick={handleLikeClick}
                        />
                    </SlTooltip>
                    <SlTooltip content="Click to provide feedback if you don't think information in the article is accurate, relevant, and useful.">
                        <SlIcon
                            className="search-result-dislike"
                            label="Icon label"
                            src={isDisliked ? "/Icons/Dislike_Active.svg" : "/Icons/Dislike.svg"}
                            style={{ color: isDisliked ? "#461e96" : "inherit", cursor: "pointer" }}
                            weight="medium"
                            onClick={handleDislikeClick}
                        />
                    </SlTooltip>
                    <SlTooltip content={copyTooltipText} hoist>
                        <SlIcon
                            className="search-result-copy"
                            src="/Icons/common-file-double-2.svg"
                            onClick={handleCopyAiSummary}
                            onMouseEnter={resetCopyTooltip}
                            style={{ cursor: 'pointer' }}
                        />
                    </SlTooltip>
                </div>

            </div>
            <span className="search-result-title">
                {item.title}
            </span>
            <span className="search-result-summary">
                {item.aiSummary?.length > 200 ? item.aiSummary.substring(0, 200) + '...' : item.aiSummary}
            </span>
            <div className="search-result-footer-container">

                <div className="search-result-footer-left">
                    <span className="search-result-footer-data">
                        <a href={item.sourceUrl} target="_blank" rel="noopener noreferrer" className="source-link">
                            <SlIcon
                                className="search-result-domain-icon"
                                src="/Icons/UrlIcon.svg"
                            />
                            <span>
                                {item.sourceName || 'Unknown Source'}
                            </span>
                        </a>

                    </span>
                    <span className="search-result-footer-data">
                        <SlIcon
                            className="search-result-scrapetime-icon"
                            src="/Icons/scrape_time.svg"
                        />
                        <span>
                            Scraped: {item.scrapedDate ? new Date(item.scrapedDate).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true }) : 'N/A'}
                        </span>
                    </span>
                    <span className="search-result-footer-data">
                        <SlIcon
                            className="search-result-publisheddate-icon"
                            src="/Icons/published_date.svg"
                        />
                        <span>
                            Published: {item.publishedDate ? new Date(item.publishedDate).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true }) : 'N/A'}
                        </span>
                    </span>
                </div>
                <div className="search-result-footer-right">
                    <Link to={`/details/${item.id}`} state={{ record: item }} className="search-result-view-details">View details →</Link>
                </div>
            </div>
        </SlCard>
    </div>


}